module.exports = __webpack_public_path__ + "static/4-fd40e90dfe3aa0f75427a885c14ee0a6.jpeg";